import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { TableRow, TableRowColumn } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

import styles from 'styles';
import { deleteCargoDuplicate } from 'actions/cargoes/duplicates';

class DuplicatesRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: this.props.item,
            realCargoNames: [],
            disableButton: false,
        };

        this.handleRemoveItem = this.handleRemoveItem.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.item.errors.length > 0) {
            this.setState({
                disableButton: false,
            });
        }
    }

    handleRemoveItem() {
        this.props.deleteCargoDuplicate(this.state.item);

        this.setState({
            disableButton: true,
        });
    }

    render() {
        const { name, categoryName, details } = this.state.item;

        return (
            <TableRow>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {name}
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {categoryName}
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {details}
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    <div className='update-item'>
                        <RaisedButton
                            label='Remove'
                            disabled={this.state.disableButton}
                            secondary
                            onClick={this.handleRemoveItem}
                        />
                    </div>
                </TableRowColumn>
            </TableRow>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const item = ownProps.item;

        return {
            item,
        };
    },
    dispatch => bindActionCreators({
        deleteCargoDuplicate,
    },
    dispatch),
)(DuplicatesRow);



// WEBPACK FOOTER //
// ./app/components/Cargoes/Duplicates/Row.jsx